import type { InsightsRecentSoldVehicleData } from 'Services/motorway/services/insights/insights.types';
import type { Order } from 'Types/generic';

import { ITEMS_PER_PAGE } from '../RecentSoldPrices/RecentSoldPrices.consts';

type Filters = {
	page: number;
	sortBy: string;
	sortOrder: Order;
};

export const filterRecentSoldPrices = ({
	filters,
	recentSoldPricesVehicles,
}: {
	filters: Filters;
	recentSoldPricesVehicles?: InsightsRecentSoldVehicleData[];
}): InsightsRecentSoldVehicleData[] => {
	const { page, sortBy, sortOrder } = filters;

	if (!recentSoldPricesVehicles) {
		return [];
	}

	const sortedVehicles = [...recentSoldPricesVehicles].sort((a, b) => {
		if (sortBy === 'vehicle') {
			if (!a.derivative || !b.derivative) {
				return a.derivative ? -1 : 1;
			}
			return b.derivative.localeCompare(a.derivative);
		}
		if (sortBy === 'regYear') {
			if (!a.manufactureYear || !b.manufactureYear) {
				return a.manufactureYear ? -1 : 1;
			}
			return b.manufactureYear - a.manufactureYear;
		}
		if (sortBy === 'mileage') {
			if (!a.mileage || !b.mileage) {
				return a.mileage ? -1 : 1;
			}
			return b.mileage - a.mileage;
		}
		if (sortBy === 'serviceHistory') {
			if (!a.serviceHistory || a.serviceHistory === 'skipped' || !b.serviceHistory || b.serviceHistory === 'skipped') {
				return a.serviceHistory && a.serviceHistory !== 'skipped' ? -1 : 1;
			}
			return b.serviceHistory.localeCompare(a.serviceHistory);
		}
		if (sortBy === 'soldPrice') {
			if (!a.soldPrice || !b.soldPrice) {
				return a.soldPrice ? -1 : 1;
			}
			return b.soldPrice - a.soldPrice;
		}
		return 0;
	});

	if (sortOrder === 'ASC') {
		sortedVehicles.reverse();
	}

	const paginatedVehicles = sortedVehicles.slice((page - 1) * ITEMS_PER_PAGE, page * ITEMS_PER_PAGE);

	return paginatedVehicles;
};
